import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { JourneysSelectors, useAppSelector } from "conversional-journey";
import { renderClasses } from './TrustPulse.styles';
import ImageWrapper from '../imageWrapper';
var TrustPulseComponent = function (_a) {
    var close = _a.close, display = _a.display, headline = _a.headline, image = _a.image, message = _a.message, onClick = _a.onClick, time = _a.time;
    var theme = useAppSelector(JourneysSelectors.selectTheme);
    var isActive = display.isActive;
    var styles = renderClasses(theme);
    var fadeInStyle = {
        opacity: isActive ? 1 : 0,
        top: isActive ? '20px' : '100px'
    };
    function handleClose(e) {
        e.stopPropagation();
        close();
    }
    return (_jsxs("section", { "data-testid": "trustpulse", className: styles.wrapper, style: fadeInStyle, onClick: onClick, children: [_jsx("div", { className: styles.imageContainer, children: _jsx(ImageWrapper, { src: image, alt: "location" }) }), _jsxs("div", { className: styles.content, children: [_jsxs("div", { className: styles.mainData, children: [_jsx("h4", { children: headline }), _jsx("h6", { children: message })] }), _jsxs("div", { className: styles.details, children: [_jsx("span", { className: styles.date, children: time }), _jsx("span", { className: styles.signature })] })] }), _jsx("i", { onClick: handleClose, children: _jsx(CloseIcon, {}) })] }));
};
export default TrustPulseComponent;
var CloseIcon = function () {
    return (_jsx("svg", { width: "15", height: "15", viewBox: "0 0 1792 1792", xmlns: "http://www.w3.org/2000/svg", style: { fill: '#bfc9e0' }, children: _jsx("path", { d: "M1490 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z" }) }));
};
